import * as angular from "angular";
import Pusher, { Channel } from "pusher-js";
import { DataProvider } from "../data-provider/data-provider.js";
import { CredentialsManager } from "../shared/credentials-manager";

export class SocketService {
    public pusher?: Pusher;
    public channel?: Channel;
    public currentTopic?: string;

    constructor(
        private dataProvider: DataProvider,
        private __env: any,
        private credentialsManager: CredentialsManager
    ) {}

    init(id: number | string, type: string): void {
        if (!this.pusher) {
            this.connectPusher(id, type);
        }

        const topicName = `private-${id}.${type}.${this.__env.host}`;

        if (this.currentTopic === topicName) {
            return;
        }

        if (this.currentTopic) {
            this.pusher.unsubscribe(this.currentTopic);
        }

        this.currentTopic = topicName;

        // Subscribe
        this.channel = this.pusher.subscribe(topicName);

        this.channel.bind("notification", (data: any) => {
            this.dataProvider.processSocketData(data);
        });

        this.channel.bind("pusher:subscription_error", (status: any) => {
            console.error("⛔ Auth Failed:", status);
        });
    }

    changeTopic(id: number | string, type: string): void {
        if (this.pusher) {
            this.pusher.disconnect();
            this.pusher = undefined; // Clear the instance so init() rebuilds it
        }

        // 2. Clear the current topic tracker so we don't return early
        this.currentTopic = undefined;

        // 3. Re-initialize (This will now read the NEW campaign ID and Token)
        this.init(id, type);
    }

    // New helper method to handle the connection
    private connectPusher(id: number | string, type: string): void {
        const token = this.credentialsManager.getAccessToken();

        let queryParams: string;

        if (type === "organisation") {
            const safeCampaignId = this.credentialsManager.campaignid;
            const safeOrgId = this.credentialsManager.oid || id;
            queryParams =
                "v2/organisation/broadcasting/auth?oid=" +
                safeOrgId +
                "&campaignid=" +
                safeCampaignId;
        } else {
            const safeCampaignId = this.credentialsManager.campaignid || id;
            queryParams =
                "v2/campaign/broadcasting/auth?campaignid=" + safeCampaignId;
        }

        this.pusher = new Pusher(this.__env.reverb_app_key, {
            wsHost: this.__env.wsUrl(),
            wsPort: this.__env.reverb_port,
            wssPort: this.__env.reverb_port,
            forceTLS: true,
            disableStats: true,
            enabledTransports: ["ws", "wss"],
            cluster: "",

            authEndpoint: queryParams,

            auth: {
                headers: {
                    Authorization: "Bearer " + token,
                    Accept: "application/json",
                },
            },
        });

        this.pusher.connection.bind("connected", (): void => {
            console.log("✅ Reverb Connected");
        });
    }
}

angular
    .module("socket", [])
    .service("SocketService", [
        "DataProvider",
        "__env",
        "CredentialsManager",
        SocketService,
    ]);
